module.exports = __webpack_public_path__ + "static/about-poster-945bb93ae3dc1d438236bb52f2df18a3.jpg";